import React from 'react';
import './mail.css';
import MailchimpForm from './mailchimpForm.jsx';
import AnimationPlayOnSectionAppear from '../../../hooks/AnimationPlayOnSectionAppear';
import side_swarm_panel_1 from '../../../assets/images/mail-image.png';

const Mail = () => {
  return (
    <div className='papercactus__mail_section'>
      <a id="mailinglist"/>
      <AnimationPlayOnSectionAppear className='fade-in-section'>
        {/* Original overlapping image for large screens */}
        <div className='papercactus__mail_image desktop-only-image'>
          <img src={side_swarm_panel_1} alt="game preview"/>
        </div>
        <div className='papercactus__mail_container'> 
          {/* Duplicate image inside container for small screens */}
          <div className='papercactus__mail_image_mobile mobile-only-image'>
            <img src={side_swarm_panel_1} alt="game preview"/>
          </div>
          <div className='papercactus__mail_content'>
            <h1>Want the Latest Updates?</h1>
            <div className="mail__signup">
              <MailchimpForm />
            </div>
          </div>
        </div>
      </AnimationPlayOnSectionAppear>
    </div>
  )
};

export default Mail;